/**
 * Platform detection — OS-aware UI affordances.
 *
 * `navigator.platform` is deprecated but still the most reliable way to
 * detect Mac vs Windows/Linux for keyboard-shortcut hints. `userAgentData`
 * is not yet broadly available.
 */

function detectMac(): boolean {
  if (typeof navigator === "undefined") return false;
  const platform = navigator.platform || "";
  const ua = navigator.userAgent || "";
  return /Mac|iPhone|iPad|iPod/i.test(platform) || /Macintosh/i.test(ua);
}

export const isMac: boolean = detectMac();

/** Display label for the primary modifier — `⌘` on Mac, `Ctrl` elsewhere. */
export const cmdKey: string = isMac ? "⌘" : "Ctrl";

/** Compact label suitable for kbd pills, e.g. `⌘K` or `Ctrl K`. */
export function shortcutLabel(letter: string): string {
  return isMac ? `${cmdKey}${letter}` : `${cmdKey} ${letter}`;
}
